import Heading, {HEADING_TYPES} from '@frontend/ui-kit/Components/Heading';
import styles from './index.module.scss';

const BenefitsAnalysis = () => {
    return (
        <div className={styles['benefits-analysis']}>
            <Heading type={HEADING_TYPES['1']}>
                Benefits Analysis
            </Heading>
        </div>
    );
};

export {BenefitsAnalysis as TestableBenefitsAnalysis};
export default BenefitsAnalysis;
